import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faRefresh,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { Popover, PopoverAnchor, PopoverContent, RangeInput } from ".";
import { isEmptyObject } from "../helpers";
import classnames from "classnames";

const EditPopover = ({
  label,
  children,
  canReset,
  onReset,
  className,
  contentWidth,
  resetPlacement,
  resetIcon,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const classes = classnames(
    "grigora-edit-popover-ui-kit-input select-none text-grigora-base flex w-full mb-2 gap-4 items-center",
    className,
  );

  return (
    <div className={classes}>
      {" "}
      {label && (
        <div className="grigora-edit-popover-ui-kitinput__label flex flex-1 ">
          {label}
        </div>
      )}
      <div className="flex items-center">
        {canReset && resetPlacement !== "right" ? (
          <>
            <div
              onClick={onReset}
              className="mr-2 cursor-pointer hover:rotate-15 duration-300"
            >
              <FontAwesomeIcon
                className=""
                icon={resetIcon ? resetIcon : faRotateRight}
              />
            </div>
          </>
        ) : null}
        <Popover placement="left">
          <PopoverAnchor open={isOpen} onOpenChange={setIsOpen}>
            <div className="px-2 py-1 bg-editor-dark-main cursor-pointer">
              <FontAwesomeIcon icon={faPen} size="sm" />
            </div>
          </PopoverAnchor>
          <PopoverContent className="!z-[1000] !shadow-editor-floating-elements !rounded-[21px] !bg-editor-light-main">
            <div
              style={{
                width: contentWidth,
              }}
              className="p-3 w-[160px] rounded-[6px]"
            >
              {children}
            </div>
          </PopoverContent>
        </Popover>
        {canReset && resetPlacement === "right" ? (
          <>
            <div
              onClick={onReset}
              className="ml-2 cursor-pointer hover:rotate-15 duration-300"
            >
              <FontAwesomeIcon
                className=""
                icon={resetIcon ? resetIcon : faRotateRight}
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default EditPopover;
